<template lang="html">
  <div class="order-by">
    <!--  Desktop template  -->
    <div class="order-by-desktop d-none d-md-block">
      <select class="form-control order-by-desktop-select"
              id="orderResults"
              @change="handleSelectOrderBy">
        <template v-for="(order, index) in orderBy" >
          <option
            class="order-by-desktop-select-option"
            :selected="activeOrder && activeOrder.name === order.name"
            :key="`order_by_${index}`"
            :value="order.name">
            {{ order.text }}
          </option>
        </template>
        <font-awesome-icon :icon="[ 'fas', 'angle-down' ]"/>
      </select>
    </div>
    <!--  Mobile template  -->
    <div class="d-block d-sm-none filter-mob-card mb-1">
      <div class="filter-mob-card-head" v-on:click="isOpen = !isOpen">
        <h6>Ordenar resultados</h6>
        <font-awesome-icon :icon="[ 'fas', 'angle-up' ]" :class="`filter-mob-right ${isOpen ?  'show' : ''}`"/>
      </div>
      <div class="filter-mob-card-info" v-bind:class="{'show' : isOpen }">
        <ol class="filter-mob-card-info-list">
          <template v-for="(order, index) in orderBy">
            <li v-if="order.name !== 'relevance' || order.name === 'relevance'"
                :key="index"
                @click="handleClickOrderBy(order)">
              <ol class="filter-mob-card-info-inline">
                <li style="color: #6c757d">{{ order.text }}</li>
              </ol>
            </li>
          </template>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'

export default {
  props: {
    filters: Array
  },

  data: () => ({
    orderBy: [
      { text: 'Ordenar por relevancia', key: 'sort_by_relevance_Ordenar por', val: 'relevancia_desc', name: 'relevance' },
      // { text: 'Ordenar por menor precio', key: 'sort_by_price_Ordenar por', val: 'menor precio_asc', name: 'priceAsc' },
      // { text: 'Ordenar por mayor precio', key: 'sort_by_price_Ordenar por', val: 'mayor precio_desc', name: 'priceDesc' },
      { text: 'Ordenar por más cercano', key: 'sort_by_distance_Ordenar por', val: 'más cercano_asc', name: 'distance' },
      { text: 'Ordenar por más reciente', key: 'sort_by_date_Ordenar por', val: 'más reciente_desc', name: 'dateDesc' },
      // { text: 'Más antiguo', key: 'sort_by_date_Ordenar por', val: 'más antiguo_asc', name: 'dateAsc' }
    ],
    isOpen: false
  }),

  computed: {
    q: () => store.state.q,

    activeOrder () {
      const orderQuery = this.filters && this.filters.filter(f => f.key.startsWith('sort_by_'))
      const order = orderQuery.length > 0 && orderQuery[0]
      if (order && this.orderBy.filter(f => f.key === order.key && f.val === order.val)[0]) {
        return this.orderBy.filter(f => f.key === order.key && f.val === order.val)[0]
      } else {
        return this.orderBy[0]
      }

    }
  },

  methods: {
    handleSelectOrderBy (e) {
      const selected = this.orderBy.filter(f => f.name === e.target.value)
      const order = selected.length > 0 && selected[0]
      if (order) {
        if (this.activeOrder) {
          store.dispatch('filters/removeSimple', this.activeOrder)
        }
        this.$emit('addFilter', {key: order.key, val: order.val})
      }
    },

    handleClickOrderBy (order) {
      if (this.activeOrder) {
        store.dispatch('filters/removeSimple', this.activeOrder)
      }
      this.$emit('addFilter', {key: order.key, val: order.val})
      this.$emit('close')
      this.isOpen = false
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/colors';

.order-by {
  &-label {
    font-weight: bold;
    font-size: 1rem;
  }

  &-desktop {
    &-select {
      line-height: 1;
      font-size: 0.8rem;
      font-weight: bold;
      color: $secondary;
      height: 20px !important;
      background: $gray-200;
      padding: 0;
      border: none;

      &:focus {
        background-color: $gray-200;
        border: none;
      }

      &-option {
        font-size: 0.8rem;
        font-weight: bold;
        color: $secondary;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/filters/Order.vue